<template>
      <v-layout justify-space-between class="">
        <v-flex xs4 text-xs-left>{{label}}</v-flex>
        <v-flex xs4 text-xs-right >{{ formatVal(value) }}</v-flex>
      </v-layout>
</template>

<script>
import utils from '../../../utils.ts'

export default {
  name: 'OrderSummaryItem',
  props: ['label', 'value'],
  methods: {
    formatVal: function (val) {
      // Make the val a currency if possible.
      if (isNaN(val)) {
        return val
      } else {
        return utils.formatCurrency(val)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
